import React from "react";
import "./about.css";
import Image from "../../assets/girl-cartoon-rembackground.png";

const About = () => {
  return (
    <section className="about container section" id="about">
      <h2 className="section__title">About Me</h2>

      <div className="about__container grid">
        <img src={Image} alt="" className="about__img" />

        <div className="about__data grid">
          <div className="about__info">
          <p className="about__description">
  I am Selma Halvorsen, 24 years old from Bergen. I’m a curious mind with a passion for learning and a heart for helping others. I love connecting with people, so don't hesitate to reach out or download my CV for more about my journey!
</p>

            <a href="/cv-selma.pdf" className="btn" download>
              Download CV
            </a>
          </div>

          <div className="about__skills grid">
            <div className="skills__data">
              <div className="skills__titles">
                <h3 className="skills__name">Java</h3>
              </div>

              <div className="skills__bar">
                <span className="skills__percentage java"></span>
              </div>
            </div>

            <div className="skills__data">
              <div className="skills__titles">
                <h3 className="skills__name">Javascript</h3>
              </div>

              <div className="skills__bar">
                <span className="skills__percentage javascript"></span>
              </div>
            </div>

            <div className="skills__data">
              <div className="skills__titles">
                <h3 className="skills__name">Git</h3>
              </div>

              <div className="skills__bar">
                <span className="skills__percentage git"></span>
              </div>
            </div>

            <div className="skills__data">
              <div className="skills__titles">
                <h3 className="skills__name">C++</h3>
              </div>

              <div className="skills__bar">
                <span className="skills__percentage cpp"></span>
              </div>
            </div>

            <div className="skills__data">
              <div className="skills__titles">
                <h3 className="skills__name">C#</h3>
              </div>

              <div className="skills__bar">
                <span className="skills__percentage cs"></span>
              </div>
            </div>   
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
